
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire73bb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire73bb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $cc3xD = parcelRequire("cc3xD");

var $lrKvI = parcelRequire("lrKvI");

var $inIMS = parcelRequire("inIMS");

var $c3RIb = parcelRequire("c3RIb");

var $9DiKA = parcelRequire("9DiKA");

var $l7vEP = parcelRequire("l7vEP");

var $bnthu = parcelRequire("bnthu");

var $bdrRp = parcelRequire("bdrRp");

var $9jDAx = parcelRequire("9jDAx");

var $4mWlF = parcelRequire("4mWlF");

var $5DwXE = parcelRequire("5DwXE");
const $241cfc2402b5464a$var$raster = new (0, $4mWlF.default)({
    source: new (0, $9jDAx.default)()
});
const $241cfc2402b5464a$var$vector = new (0, $bdrRp.default)({
    style (feature, resolution) {
        const fillColor = feature.get("fillColor") || "white";
        const strokeColor = feature.get("strokeColor") || "grey";
        return new (0, $c3RIb.default)({
            fill: new (0, $inIMS.default)({
                color: fillColor
            }),
            stroke: new (0, $lrKvI.default)({
                color: strokeColor,
                width: 1
            })
        });
    },
    source: new (0, $bnthu.default)({
        format: new (0, $l7vEP.default)(),
        url: "data/geojson/buildings.geojson"
    })
});
const $241cfc2402b5464a$var$map = new (0, $5DwXE.default)({
    layers: [
        $241cfc2402b5464a$var$raster,
        $241cfc2402b5464a$var$vector
    ],
    target: "map2d",
    view: new (0, $9DiKA.default)({
        center: [
            0,
            0
        ],
        zoom: 2
    })
});
// Enable the property 'olcs_shadows' for the entire set of features
// Alternatively, you can enable 'olcs_shadows' for each feature individually
$241cfc2402b5464a$var$vector.set("olcs_shadows", true);
const $241cfc2402b5464a$var$ol3d = new (0, $cc3xD.default)({
    map: $241cfc2402b5464a$var$map,
    target: "map3d"
});
$241cfc2402b5464a$var$ol3d.setEnabled(true);
// Be aware that enabling the following properties can impact performance
// Enable shadow map to allow Cesium to cast scene's shadows
const $241cfc2402b5464a$var$scene = $241cfc2402b5464a$var$ol3d.getCesiumScene();
$241cfc2402b5464a$var$scene.shadowMap.enabled = true;
// Enable lighting the globe with the sun as a light source to have dynamic lighting conditions according to the position of the sun
$241cfc2402b5464a$var$scene.globe.enableLighting = true;
const $241cfc2402b5464a$var$vectorSource = $241cfc2402b5464a$var$vector.getSource();
$241cfc2402b5464a$var$vectorSource.once("featuresloadend", ()=>{
    if ($241cfc2402b5464a$var$vectorSource.getState() === "ready") $241cfc2402b5464a$var$map.getView().fit($241cfc2402b5464a$var$vector.getSource().getExtent());
});
const $241cfc2402b5464a$var$selectionStyle = new (0, $c3RIb.default)({
    fill: new (0, $inIMS.default)({
        color: [
            0,
            255,
            0,
            1
        ]
    }),
    stroke: new (0, $lrKvI.default)({
        color: [
            0,
            153,
            255,
            1
        ],
        width: 3
    })
});
let $241cfc2402b5464a$var$selectedFeature;
$241cfc2402b5464a$var$map.on("click", (e)=>{
    if ($241cfc2402b5464a$var$selectedFeature) $241cfc2402b5464a$var$selectedFeature.setStyle(null);
    $241cfc2402b5464a$var$selectedFeature = $241cfc2402b5464a$var$map.forEachFeatureAtPixel(e.pixel, (feature, layer)=>feature);
    if ($241cfc2402b5464a$var$selectedFeature) $241cfc2402b5464a$var$selectedFeature.setStyle($241cfc2402b5464a$var$selectionStyle);
});


//# sourceMappingURL=buildings.15b6f12a.js.map
